import styled from '@emotion/styled';

export const StyledSeparator = styled.span`
  margin: 0 2px;
  span {
    font-size: 8px;
  }
`;
